import React, { useState, useEffect } from "react";

import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';

import Sketch from '@uiw/react-color-sketch';
import { hsvaToHex, hsvaToHexa, validHex } from '@uiw/color-convert';



function ColorPickerDialog (props) {
    const {
        title='Choose Color',
        open,
        color,
        onSave,
        onCancel,
        disableAlpha=false,
        ...other
    } = props;

    const [okEnabled, setOkEnabled] = useState(true);
    const [colorValue, setColorValue] = useState("#fff");

    useEffect( () => {
        if ( open ) {
            if ( validHex(color) ) {
                setColorValue(color);
            } else {
                setColorValue('#000');
            }
        }
    },[open,color]);
    

    const PRESET_COLORS = [
        '#D0021B',
        '#F5A623',
        '#f8e61b',
        '#8B572A',
        '#7ED321',
        '#417505',
        '#BD10E0',
        '#9013FE',
    ];

    const onOKClick = () => {
        if ( typeof onSave === 'function' ) {
            let c = colorValue;
            if ( typeof colorValue !== 'string' ) {
                c = disableAlpha ? hsvaToHex(colorValue) : hsvaToHexa(colorValue);
            }
            onSave(c);
        }
    }

    const onCancelClick = () => {
        onClose();
    };

    const onClose = (event, reason) => {
        if ( reason === 'backdropClick') {
            return;
        }
        if ( typeof onCancel === 'function' ) {
            onCancel();
        }
    };

    const handleColorChange = (c) => {
        // console.log('Color: ' + JSON.stringify(c));
        // console.log('Color: ' + JSON.stringify(hsvaToHexa(c.hsva)));
        setColorValue(c.hsva);
    };

    return (
        <Dialog
            maxWidth={'900px'}
            open={open}
            onClose={onClose}
            slotProps={{
                paper: { 
                    sx: {
                        minWidth: 470,
                        maxWidth: 700,
                        maxHeight: 750,
                        minHeight: 530,
                    }
                }
            }}
        >
            <DialogTitle sx={{fontWeight: 'bold'}}>{title}</DialogTitle>
            <DialogContent>
                <Box sx={{display: 'flex', justifyContent: 'center',  paddingTop: 3, location: 'relative', top: '10px',
                    overflow: 'visible',   }}>
                    <Sketch
                        style={{ marginLeft: 10, marginRight: 10, marginTop: '20px', transform: 'scale(1.31)'}}
                        color={colorValue}
                        width="300px"
                        disableAlpha={disableAlpha}
                        presetColors={PRESET_COLORS}
                        onChange={handleColorChange}
                    />
                </Box>
            </DialogContent>
            <DialogActions sx={{padding: 3}}>
                <Box>
                    <Button variant="outlined" onClick={() => onOKClick()} sx={{ minWidth: '7em' }} disabled={!okEnabled} >OK</Button>
                    <Button variant="outlined" onClick={onCancelClick} sx={{ minWidth: '7em', marginLeft: 2 }}>Cancel</Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
}

export { ColorPickerDialog };